import React from 'react'
import { TaxExemptionStatus } from 'TypeDefs/TaxExemptionStatusTracker'
import useStyles from './StatusPrompt.styles'
import { Box, Typography, Button } from '@material-ui/core'
import statusList from 'Components/Pages/Services/FormationDashboard/StatusTracker/statusList'
import { useHistory } from 'react-router-dom'

type Props = {
  currentStatus: TaxExemptionStatus
}
const StatusPrompt = ({ currentStatus }: Props) => {
  const classes = useStyles()
  const history = useHistory()
  const [positionOnLoad] = statusList.filter(
    (status) => status.key === currentStatus
  )

  const handleClick = () => {
    history.push(positionOnLoad.path)
  }

  return (
    <Box mb={3} p={3} borderRadius={4} className={classes.box}>
      <Typography className={classes.title} variant='h5'>
        {positionOnLoad.description}
      </Typography>

      <Button
        variant='contained'
        color='primary'
        onClick={handleClick}
        data-testid='startPrompt'
      >
        Start
      </Button>
    </Box>
  )
}

export default StatusPrompt
